export function buildLaborModelInitialApiCalls(endpoints) {
  return {
    roleTypes: endpoints.roleTypes,
    storesInfo: endpoints.storesInfo,
    roleNames: endpoints.roleNames,
    laborModelScenarios: endpoints.laborModelScenarios,
  };
}

export function buildLaborModelCompanyApiParams(companyId, companyStores = []) {
  return {
    company_id: companyId,
    store_id: companyStores[0]?.id,
  };
}

export function canLoadLaborPlanSummary(selectedCompanyId, modelEditorReady) {
  return Boolean(selectedCompanyId && modelEditorReady);
}
